import React, { useRef, useState, FunctionComponent } from "react";
import styles from "./VideoShorts.module.scss";
import VideoShortsProps from "./VideoShorts.interface";

import combineClasses from "helpers/combine-classes";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import { YouTubeEmbed } from "react-social-media-embed";
import VideoViewer from "components/VideoViewer/VideoViewer";

const VideoShorts: FunctionComponent<VideoShortsProps> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);

    const overflowClass = props.content.videoShortsList && props.content?.videoShortsList.length > 1 ? styles.overflow : "";

    const slider = useRef(null) as any;
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [startScroll, setStartScroll] = useState(0);
    const [activeClass, setActiveClass] = useState("");

    const handleMouseDown = (event: React.MouseEvent) => {
        setIsDragging(true);
        setActiveClass(styles.active);
        setStartX(event.clientX - slider.current.getBoundingClientRect().left);
        setStartScroll(slider.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        if (!isDragging) return;
        setIsDragging(false);
        setActiveClass("");
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        setActiveClass("");
    };

    const handleMouseMove = (event: React.MouseEvent) => {
        if (!isDragging) return;
        event.preventDefault();
        const x = event.clientX - slider.current.getBoundingClientRect().left;
        const walk = (x - startX) * 3;
        slider.current.scrollLeft = startScroll - walk;
    };

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {/* Content */}
                <div className={styles.content}>
                    <div className={styles.inner}>
                        <div
                            ref={slider}
                            className={combineClasses([styles.video_shorts_list, activeClass, overflowClass])}
                            onMouseDown={handleMouseDown}
                            onMouseLeave={handleMouseLeave}
                            onMouseUp={handleMouseUp}
                            onMouseMove={handleMouseMove}
                        >
                            {props.content.videoShortsList && props.content.videoShortsList.length > 0 ? (
                                <>
                                    {props.content.videoShortsList
                                        .filter((item) => item != null)
                                        .map((item, index) => {
                                            const isAutoplay = item?.autoplay ? item.autoplay : false;
                                            const isLoop = item?.loop ? item.loop : false;

                                            return (
                                                <div
                                                    className={styles.video_shorts_item}
                                                    key={index}
                                                >
                                                    {item?.youtubeShortItem && !item?.media ? (
                                                        <YouTubeEmbed url={item?.youtubeShortItem?.toString() || ""} />
                                                    ) : null}

                                                    {item?.media && !item?.youtubeShortItem ? (
                                                        <VideoViewer
                                                            key={item?.media._id}
                                                            src={item?.media?.url || ""}
                                                            heightRatio={690 / 1280}
                                                            loop={isLoop}
                                                            soundButton={false}
                                                            className={styles.video}
                                                            autoplay={isAutoplay}
                                                            isRounded={true}
                                                        />
                                                    ) : null}
                                                </div>
                                            );
                                        })}
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoShorts;
